import Api from '@op/opds.api-base';

class RestApi {
  constructor() {
    this.api = new Api(window.PRICELIST_DISPLAY_URL, {
      timeout: {
         connect: 3000, // 3 second connection timeout
         socket: 5000, // 5 seconds socket/read timeout
       },
    });
  }

  getPricelistContents = async (bankNumber, targetGroupId, skipCache, lang, effectiveDate) => {
    let url = `/pricelist-web/v1/rest/contents/${bankNumber}/${targetGroupId}?skipCache=${skipCache}&lang=${lang}`;
    if (effectiveDate) {
        url += `&effectiveDate=${effectiveDate}`;
    }
    const response = await this.api.get(url);
    return response;
  }

  getPricelist = async (bankNumber, targetGroupId, productGroup, skipCache, lang, effectiveDate) => {
    let url = `/pricelist-web/v1/rest/prices/productgroup/${bankNumber}/${targetGroupId}/${productGroup}?skipCache=${skipCache}&lang=${lang}`;
    if (effectiveDate) {
      url += `&effectiveDate=${effectiveDate}`;
    }
    const response = await this.api.get(url);
    return response;
  }
}

const restApi = new RestApi();

export default restApi;